import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { sessionContractIdSelector } from '../../../redux/session/contract/selectors'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'
import { showSuccessMessage, showErrorMessage } from '../../../utils/message'
import { sendDeliverySubscription } from '../service/deliverySubscriptionService'
import deliverySubscriptionQueryKeys from './deliverySubscriptionQueryKeys'

export const useSendDeliverySubscription = () => {
  const contractId = useSelector(sessionContractIdSelector)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: DeliverySubscription['id']) => sendDeliverySubscription(contractId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: deliverySubscriptionQueryKeys.list(contractId) })
      showSuccessMessage()
    },
    onError: () => showErrorMessage()
  })
}
